module.exports = __webpack_public_path__ + "static/cover-video-5923c0b920425124b8dd09fbae82a331.png";